module.exports = __webpack_public_path__ + "static/media/value3.3b1cf752.svg";